<template>
  <div class="monitor-container">
    <div v-if="showMonitorinfo==1">
      <van-nav-bar
        title="监控系统"
        left-arrow
        @click-left="onClickLeft"
        safe-area-inset-top fixed placeholder z-index="100"
      >
        <template #right>
          <a class="journal" @click.prevent="$router.push('/mobile/journal')">日志</a>
        </template>
      </van-nav-bar>
      <el-alert type="success" :closable="false">
        <span>使用前需知：请确保检测点和监控额度足够，否则会自动关闭任务，不执行告警通知或回调。请合理设置监控频率，否则会导致检测点被快速用完。</span>
        <el-link @click="$router.push('mall')" type="info" :underline="false">前往购买</el-link>
        |
        <el-link @click="$router.push('noticeAccount')" type="info" :underline="false">添加渠道</el-link>
      </el-alert>

      <!--搜索栏-->
      <van-search
        v-model.trim="search"
        shape="round"
        @keyup="searchName()"
        @clear="searchName()"
        clearable
        placeholder="请输入任务名、任务编号或监控目标"
      />

      <!--操作栏-->
      <van-grid :column-num="4" :border="false" class="OperationButtonGrid">
        <van-grid-item>
          <!-- 启用操作 -->
          <van-popover
            v-model="showPopover.showStartPopover"
            trigger="click"
            :actions="operateAction.startAction"
            @select="actionSelect"
            placement="bottom-start"
          >
            <template #reference>
              <el-button style="color:#67C23A;font-weight: bold;" size="mini">
                启用操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
            </template>
          </van-popover>
        </van-grid-item>
        <van-grid-item>
          <!-- 停用操作 -->
          <van-popover
            v-model="showPopover.showStopPopover"
            trigger="click"
            :actions="operateAction.stopAction"
            @select="actionSelect"
            placement="bottom-start"
          >
            <template #reference>
              <el-button style="color: #606266;font-weight: bold;" size="mini" :disabled="tableData.length==0">
                停用操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
            </template>
          </van-popover>
        </van-grid-item>

        <van-grid-item>
          <!-- 删除操作 -->
          <van-popover
            v-model="showPopover.showDelPopover"
            trigger="click"
            :actions="operateAction.delAction"
            @select="actionSelect"
            placement="bottom-end"
          >
            <template #reference>
              <el-button style="color: #da2153;font-weight: bold;" size="mini" :disabled="tableData.length==0">
                删除操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
            </template>
          </van-popover>
        </van-grid-item>

        <van-grid-item>
          <!-- 导出操作 -->
          <van-popover
            v-model="showPopover.showExportsPopover"
            trigger="click"
            :actions="operateAction.exportsAction"
            @select="exportSelect"
            placement="bottom-end"
          >
            <template #reference>
              <el-button style="color: #409EFF;font-weight: bold;" size="mini">
                导出表格<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
            </template>
          </van-popover>
        </van-grid-item>
      </van-grid>

      <!-- 筛选栏 -->
      <van-tabs class="FilterTabBar" :ellipsis="false" animated sticky lazy-render line-width="0">
        <van-tab>
          <template #title>
            <van-tag type="info" size="medium" @click.prevent="resetALlSelectBtn()">重置所有筛选</van-tag>
          </template>
        </van-tab>
        <!--筛选方式-->
        <van-tab>
          <template #title>
            <van-popover
              v-model="filterResult.showApiPopover"
              trigger="click"
            >
              <van-checkbox-group v-model="filterResult.apiResult" ref="apiCheckboxRef" @change="filterBar('api')" style="height: 200px;overflow:scroll;">
                <van-checkbox shape="square" icon-size="0.9rem" v-for="item in apilist" :key="item.value" :name="item.value">
                  {{item.text }}
                </van-checkbox>
              </van-checkbox-group>
              <template #reference>
                <van-tag size="medium">方式
                  <van-icon name="arrow-down"/>
                </van-tag>
              </template>
            </van-popover>
          </template>
        </van-tab>
        <!--通知渠道-->
        <van-tab>
          <template #title>
            <van-popover
              v-model="filterResult.showNoticePopover"
              trigger="click"
              placement="bottom-start"
            >
              <van-checkbox-group v-model="filterResult.noticeResult" ref="noticeCheckboxRef" @change="filterBar('notice')">
                <van-checkbox shape="square" icon-size="0.9rem" name="2">短信</van-checkbox>
                <van-checkbox shape="square" icon-size="0.9rem" name="3">电话</van-checkbox>
                <van-checkbox shape="square" icon-size="0.9rem" name="1">邮件</van-checkbox>
                <van-checkbox shape="square" icon-size="0.9rem" name="4">微信</van-checkbox>
                <van-checkbox shape="square" icon-size="0.9rem" name="5">钉钉</van-checkbox>
                <van-checkbox shape="square" icon-size="0.9rem" name="6">电报</van-checkbox>
                <van-checkbox shape="square" icon-size="0.9rem" name="7">企业微信</van-checkbox>
                <van-checkbox shape="square" icon-size="0.9rem" name="8">飞书</van-checkbox>
              </van-checkbox-group>
              <template #reference>
                <van-tag size="medium">通知渠道
                  <van-icon name="arrow-down"/>
                </van-tag>
              </template>
            </van-popover>
          </template>
        </van-tab>
        <!--域名状态-->
        <van-tab>
          <template #title>
            <van-popover
              v-model="filterResult.showUrlStatePopover"
              trigger="click"
              placement="bottom-start"
            >
              <van-checkbox-group v-model="filterResult.urlStateResult" ref="urlStateCheckboxRef"
                                  @change="filterBar('urlstate')">
                <van-checkbox shape="square" icon-size="0.9rem" name="1">正常</van-checkbox>
                <van-checkbox shape="square" icon-size="0.9rem" name="0">异常</van-checkbox>
                <van-checkbox shape="square" icon-size="0.9rem" name="2">未知</van-checkbox>
              </van-checkbox-group>
              <template #reference>
                <van-tag size="medium">状态
                  <van-icon name="arrow-down"/>
                </van-tag>
              </template>
            </van-popover>
          </template>
        </van-tab>
        <!-- 启用状态 -->
        <van-tab>
          <template #title>
            <van-popover
              v-model="filterResult.showStateSwitchPopover"
              trigger="click"
              placement="bottom-end"
            >
              <van-checkbox-group v-model="filterResult.stateSwitchResult" ref="stateSwitchCheckboxRef"
                                  @change="filterBar('stateswitch')">
                <van-checkbox shape="square" icon-size="0.9rem" name="1">已启用</van-checkbox>
                <van-checkbox shape="square" icon-size="0.9rem" name="0">未启用</van-checkbox>
              </van-checkbox-group>
              <template #reference>
                <van-tag size="medium">启用
                  <van-icon name="arrow-down"/>
                </van-tag>
              </template>
            </van-popover>
          </template>
        </van-tab>
        <!-- 自动停用状态 -->
        <van-tab>
          <template #title>
            <van-popover
              v-model="filterResult.showSwitchPopover"
              trigger="click"
              placement="bottom-end"
            >
              <van-checkbox-group v-model="filterResult.switchResult" ref="switchCheckboxRef"
                                  @change="filterBar('switch')">
                <van-checkbox shape="square" icon-size="0.9rem" name="1">已启用</van-checkbox>
                <van-checkbox shape="square" icon-size="0.9rem" name="0">未启用</van-checkbox>
              </van-checkbox-group>
              <template #reference>
                <van-tag size="medium">自动停用
                  <van-icon name="arrow-down"/>
                </van-tag>
              </template>
            </van-popover>
          </template>
        </van-tab>
      </van-tabs>

      <!--添加监控任务按钮-->
      <el-button class="addTaskBtn" type="primary" size="mini" @click="showaddBox()">+</el-button>

      <!--监控任务为空的状态-->
      <van-empty image="error" v-if="showError" style="padding: 0" image-size="100" description="暂无监控任务"/>

      <!-- 监控任务列表 -->
      <van-cell-group v-loading="loading" style="background-color: transparent;">
        <van-panel class="panelMonitor" v-for="(item,i) in tableData" :key="item.id">
          <van-grid :column-num="2" :border="false" @click.native="monitorinfo(item)">
            <van-grid-item style="flex-basis: 70%">
              <div class="monitorName">{{ item.name }}</div>
              <div class="monitorContent">
                方式:{{ item.project }}<br>
                检测频率:{{ item.time }}分钟
              </div>
            </van-grid-item>
            <van-grid-item style="flex-basis: 30%">
              <!--正常或异常状态-->
              <div v-if="[0,1].includes(item.urlstate)"
                    :class="['invoicing',item.urlstate == 0 ? 'invoicing0' : 'invoicing1']">
                {{ item.urlstate == 0 ? '异常' : '正常' }}
              </div>
              <!-- 未知状态 -->
              <div v-else class="invoicing">未知</div>
              <!-- 通知账户 -->
              <div style="margin: 1rem 1.8rem 0 0">
                <svg
                  v-if="item.tongzhitype!='5' && item.tongzhitype!='6' && item.tongzhitype!='7' && item.tongzhiswitch"
                  class="icon" aria-hidden="true">
                  <use v-if="item.tongzhitype == '4'" xlink:href="#icon-weixin"></use>
                  <use v-else-if="item.tongzhitype == '2'" xlink:href="#icon-xinxiduanxinsixinduihua"></use>
                  <use v-else-if="item.tongzhitype == '1'" xlink:href="#icon-icon-test"></use>
                  <use v-else-if="item.tongzhitype == '3'" xlink:href="#icon-dianhuabeifen"></use>
                  <use v-else-if="item.tongzhitype == '8'" xlink:href="#icon-feishu"></use>
                  <!--  <use v-else-if="scoped.row.tongzhitype == '7'" xlink:href="#icon-icon-test1"></use> -->
                </svg>
                <svg v-else-if="item.tongzhiswitch && item.tongzhitype=='5'" class="icon dingding_icon">
                  <use xlink:href="#icon-dingding"></use>
                </svg>
                <svg v-else-if="item.tongzhiswitch && item.tongzhitype=='6'" class="icon dingding_icon">
                  <use xlink:href="#icon-telegram"></use>
                </svg>
                <svg v-else-if="item.tongzhiswitch && item.tongzhitype=='7'" class="icon dingding_icon">
                  <use xlink:href="#icon-icon-test1"></use>
                </svg>
                <svg v-else class="icon">
                  <use v-if="!item.tongzhiswitch" xlink:href="#icon-jinyong"></use>
                </svg>
              </div>
            </van-grid-item>
          </van-grid>
          <template #footer>
            <div>
              <el-checkbox v-model="item.ischecked" @change="changecheck(item.id)"></el-checkbox>
              <el-button type="success" plain size="small" icon="el-icon-s-operation" @click="testCould(item)" :loading="item.loading">
                测试
              </el-button>
              <el-button type="primary" plain size="small" icon="el-icon-edit" @click.native="editshow(item)">编辑
              </el-button>
              <el-button size="small" icon="el-icon-more" @click="showMoreBtn(item,i)">更多</el-button>
              <!-- 更多操作 -->
              <van-action-sheet
                v-model="showMoreBox[i]"
                :title="moreData.name"
                close-on-click-action
                safe-area-inset-bottom
                get-container="body"
              >
                <van-cell-group>
                  <van-cell title="启用">
                    <el-switch @change="change_stateswitch(moreData.id)" v-model="moreData.stateswitch == 1"
                                active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                  </van-cell>
                  <van-cell title="自动停用">
                    <template #extra>
                      <el-switch :value="moreData.switch == 1" active-color="#13ce66" inactive-color="#ccc"
                                  @change="change_switch(moreData.id)"></el-switch>
                    </template>
                  </van-cell>
                  <van-cell @click="delrow(moreData.id)">
                    <template #title>
                      <div class="deleteBtn">
                        <van-icon name="delete-o" />删除
                      </div>
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-action-sheet>
            </div>
          </template>
        </van-panel>
      </van-cell-group>

      <!--分页-->
      <van-pagination
        v-model="page"
        :total-items="total"
        :show-page-size="3"
        :items-per-page="pagesize"
        force-ellipses
        v-if="total>pagesize"
        @change="gettableData()"
      >
        <template #prev-text>
          <van-icon name="arrow-left"/>
        </template>
        <template #next-text>
          <van-icon name="arrow"/>
        </template>
      </van-pagination>
    </div>
    <!-- 监控详情 -->
    <monitor-info v-if="showMonitorinfo==2" :details="details" :showMonitorinfo="showMonitorinfo"></monitor-info>

    <!-- 修改监控任务 -->
    <edit-task-mb v-if="showMonitorinfo==3" @editsuccess="editsuccess($event)" :rowData="editRow"  :father_page="page" :father_pagesize="pagesize"></edit-task-mb>
  </div>
</template>

<script>
import '@/../public/iconfont/iconfont'
import '@/../public/iconfont/iconfont1'
import MonitorInfo from './monitor/MonitorInfo'
import EditTaskMb from './monitor/EditTaskMb'

export default {
  data() {
    return {
      showPopover:{
        showStartPopover: false,
        showStopPopover: false,
        showDelPopover: false,
        showExportsPopover: false,
      },
      operateAction: {
        // 开始操作
        startAction: [
          { text: '启用选中',type:'this.start_check',disabled:true },
          { text: '启用全部',type:'this.start_all',disabled:true},
          { text: '启用异常',type:'this.start_abnorma',disabled:true},
          { text: '启用正常',type:'this.start_normal',disabled:true},
          { text: '启用未知',type:'this.start_unknown',disabled:true}
        ],
        // 停用操作
        stopAction: [
          { text: '停用选中',type:'this.stop_check',disabled:true},
          { text: '停用全部',type:'this.stop_all',disabled:true},
          { text: '停用异常',type:'this.stop_abnormal',disabled:true},
          { text: '停用正常',type:'this.stop_normal',disabled:true},
          { text: '停用未知',type:'this.stop_unknown',disabled:true}
        ],
        // 删除操作
        delAction: [
          { text: '删除选中',type:'this.delcheck',disabled:true },
          { text: '删除全部',type:'this.delall',disabled:true},
          { text: '删除停用',type:'this.delstop',disabled:true},
          { text: '删除启用',type:'this.delstart',disabled:true},
          { text: '删除异常',type:'this.delabnormal',disabled:true},
          { text: '删除正常',type:'this.delnormal',disabled:true},
          { text: '删除未知',type:'this.del_unknown',disabled:true},
          { text: '删除过期',type:'this.del_overdue',disabled:true}
        ],
        // 导出操作
        exportsAction: [
          {
            text: '导出选中',
            type: 'select',
            disabled:true
          },
          {
            text: '导出全部',
            type: 'all',
            disabled:true
          },
          {
            text: '导出启用',
            type: 'enable',
            disabled:true
          },
          {
            text: '导出停用',
            type: 'outservice',
            disabled:true
          },
          {
            text: '导出异常',
            type: 'abnormal',
            disabled:true
          },
          {
            text: '导出正常',
            type: 'normal',
            disabled:true
          },
          {
            text: '导出未知',
            type: 'unknown',
            disabled:true
          },
          {
            text: '导出过期',
            type: 'overdue',
            disabled:true
          }
        ]
      },
      // 筛选条件
      filterResult: {
        // 检测条件筛选条件
        showApiPopover:false,
        apiResult: [],
        // 通知账户筛选条件
        showNoticePopover:false,
        noticeResult: [],
        // 域名状态筛选条件
        showUrlStatePopover:false,
        urlStateResult: [],
        // 自动停用筛选条件
        showSwitchPopover:false,
        switchResult: [],
        // 启用状态筛选条件
        showStateSwitchPopover:false,
        stateSwitchResult: []
      },
      // 选中的监控任务
      selectedArray:[],
      // 显示监控任务详情
      showMonitorinfo: 1,
      // 监控任务详情数据
      details: [],
      isok: false,
      showError: false,
      showMoreBox: [],
      // 更多
      moreData: [],
      resetALlSelectBtn_isShow: false,
      apilist: [],
      loading: true,
      page: 1,
      tableData: [],
      search: '',
      dialogVisible: false,
      pagesize: 5,
      total: 0,
      selection: '',
      filterlist: {
        project: '',
        stateswitch: '',
        switch: '',
        tongzhitype: '',
        urlstate: '',
        grouping_id:''
      },
      editRow: {}
    }
  },
  components: {
    MonitorInfo,
    EditTaskMb
  },
  created() {
    this.getApiandNode()
    this.gettableData()
  },
  updated() {
    this.showError = this.total <= 0
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.onClickLeft, false)
    }
  },
  beforeUpdate() {
    if(this.tableData.length === 0){
      for (let operateActionKey in this.operateAction) {
        this.operateAction[operateActionKey].forEach(item=>{
          item.disabled = true
        })
      }
    }else{
      for (let operateActionKey in this.operateAction) {
        this.operateAction[operateActionKey].forEach(item=>{
          item.disabled = false
          this.selection === '' ? this.operateAction[operateActionKey][0].disabled = true : this.operateAction[operateActionKey][0].disabled = false
        })
      }
    }
  },
  destroyed() {
    window.removeEventListener('popstate', this.onClickLeft, false)
  },
  methods: {
    onClickLeft() {
      if (this.showMonitorinfo === 1) {
        this.$router.replace('/mobile')
      }
    },
    // 下拉菜单选择操作
    actionSelect(action){
      eval(action.type+'()')
    },
    // 导出操作下拉菜单选择
    exportSelect(action){
      this.exportsExcel(action.type)
    },
    // 筛选功能
    filterBar(type) {
      switch (type) {
        // 检测方式筛选
        case 'api':
          this.filterlist.project = this.filterResult.apiResult.join()
          break
        // 通知账户筛选
        case 'notice':
          this.filterlist.tongzhitype = this.filterResult.noticeResult.join()
          break
        // 域名状态筛选
        case 'urlstate':
          this.filterlist.urlstate = this.filterResult.urlStateResult.join()
          break
        // 启用状态筛选
        case 'stateswitch':
          this.filterlist.stateswitch = this.filterResult.stateSwitchResult.join()
          break
        // 自动停用筛选
        case 'switch':
          this.filterlist.switch = this.filterResult.switchResult.join()
          break
      }
      this.gettableData()
    },
    // 重置筛选
    resetALlSelectBtn() {
      this.selectedArray = []
      this.resetALlSelectBtn_isShow = false
      this.filterResult = {
        apiResult: [],
        noticeResult: [],
        urlStateResult: [],
        stateSwitchResult: [],
        switchResult: []
      }
      this.filterlist = {
        project: '',
        stateswitch: '',
        switch: '',
        tongzhitype: '',
        urlstate: '',
        grouping_id:''
      }
      this.search = ''
      this.page = 1
      this.gettableData()
    },
    // 查询功能
    searchName() {
      this.page = 1
      this.gettableData()
    },
    // 添加任务
    showaddBox() {
      if ((this.$store.state.package_purchased_monitor + this.$store.state.monitor - this.$store.state.monitored) <= 0) {
        return this.$notify({
          type: 'warning',
          message: '暂无可用监控额度'
        })
      } else {
        this.$router.push('/mobile/addtaskmb')
      }
    },
    getApiandNode(){
      axios.all([
        this.$http.post('/apiinterface/apilist'),
        this.$http.post('/apiinterface/nodelist')
      ]).then(data=>{
        // 获取监控方式列表
        if(data[0].data.status == 'success'){
          data[0].data.data.forEach(item => {
            this.apilist.push({text: item.name,value: item.interface_name})
          })
          const arr = data[0].data.data.filter(item => {
            return item.taskswitch == 1
          })
          this.$store.commit('setOther', {
            name: 'apilist',
            value: arr
          })
          this.isok = true
        }else{
          this.$notify({type: 'danger',message: data[0].data.msg})
        }
        // 获取节点列表
        if (data[1].data.status == 'success') {
          this.$store.commit('setOther', {
            name: 'nodelist',
            value: data[1].data.data
          })
        } else {
          this.$notify({type: 'danger',message: data[1].data.msg})
        }
      }).catch(err=>{})
    },
    //获取数据
    async gettableData() {
      try {
        this.loading = true
        this.selection = ''
        this.selectedArray = []
        const { data } = await this.$http.post('/task/tasklist/', {
          page: this.page,
          eachpage: this.pagesize,
          screen: 1,
          type: this.filterlist.project,
          switch: this.filterlist.stateswitch,
          exception: this.filterlist.switch,
          notice: this.filterlist.tongzhitype,
          status: this.filterlist.urlstate,
          grouping_id: this.filterlist.grouping_id,
          search: this.search
        })
        if (data.status == 'success') {
          data.data.data.forEach(item => {
            item.tooltip = false
            item.loading = false
            item.ischecked = false
          })
          this.tableData = data.data.data
          this.total = data.data.total
          this.loading = false
        } else {
          this.loading = true
          this.$notify({
            type: 'danger',
            message: data.msg
          })
        }
      } catch (e) {
        this.loading = true
        this.$notify({
          type: 'danger',
          message: '网络异常，请稍后重试'
        })
      }
    },
    // 监控任务详情
    monitorinfo(item) {
      this.showMonitorinfo = 2
      this.details = item
    },
    // 更多操作按钮
    showMoreBtn(item, index) {
      this.moreData = item
      this.showMoreBox = []
      const fullval = 'showMore' + index
      this.showMoreBox.push(fullval)
    },
    // 测试任务
    async testCould(row) {
      const index = this.tableData.findIndex(item => {
        return item.id == row.id
      })
      this.tableData[index].loading = true
      try {
        const { data } = await this.$http.post('/cloudtask', { id: row.id }, { timeout: 10000 })
        if (data.status == 'success') {
          this.tableData.forEach(item => {
            if (item.id == row.id) {
              item.urlstate = data.data.state
              item.urlstatemsg = data.data.msg
              item.stateswitch = data.data.stateswitch
              item.update_time = data.data.update_time
            }
          })
          this.$notify({
            type: 'success',
            message: '测试成功'
          })
        } else {
          this.$notify({
            type: 'danger',
            message: data.msg
          })
        }
        this.tableData[index].loading = false
      } catch (e) {
        this.tableData[index].loading = false
        this.$notify({
          type: 'danger',
          message: '网络异常，请稍后重试'
        })
      }
    },
    // 导出表格
    exportsExcel(type) {
      if (this.tableData.length > 0) {
        if (['select', 'unknown', 'overdue'].indexOf(type) !== -1) {
          window.open(`//api.user.urlzt.com/api/task/execl?id=${this.selection}&islogin=${localStorage.getItem('ticket')}&type=${type}`)
        } else {
          window.open(`//api.user.urlzt.com/api/task/execl?islogin=${localStorage.getItem('ticket')}&type=${type}`)
        }
      }else{
        return this.$notify({
          type: 'danger',
          message: '暂无监控任务'
        })
      }
    },
    // 停用正常
    async stop_normal() {
      try {
        const { data } = await this.$http.post('/task/stopnormal')
        if (data.status == 'success') {
          this.$notify({
            type: 'success',
            message: '停用正常成功'
          })
          this.tableData.forEach(item => {
            if (item.urlstate == 1) {
              item.stateswitch = 0
            }
          })
        } else {
          this.$notify({
            type: 'danger',
            message: data.msg
          })
        }
      } catch (e) {
        this.$notify({
          type: 'danger',
          message: '网络异常，请稍后重试'
        })
      }
    },
    //停用异常方法
    async stop_abnormal() {
      try {
        const { data } = await this.$http.post('/task/stopabnormal')
        if (data.status == 'success') {
          this.$notify({
            type: 'success',
            message: '停用异常成功'
          })
          this.tableData.forEach(item => {
            if (item.urlstate == 0) {
              item.stateswitch = 0
            }
          })
        } else {
          this.$notify({
            type: 'danger',
            message: data.msg
          })
        }
      } catch (e) {
        this.$notify({
          type: 'danger',
          message: '网络异常，请稍后重试'
        })
      }
    },
    //停用未知
    async stop_unknown() {
      try {
        const { data } = await this.$http.post('/task/stop_unknown')
        if (data.status == 'success') {
          this.$notify({
            type: 'success',
            message: '停用未知成功'
          })
          this.tableData.forEach(item => {
            if (item.urlstate == 2) {
              item.stateswitch = 0
            }
          })
        } else {
          this.$notify({
            type: 'danger',
            message: data.msg
          })
        }
      } catch (e) {
        this.$notify({
          type: 'danger',
          message: '网络异常，请稍后重试'
        })
      }
    },
    //停用全部
    async stop_all() {
      try {
        const { data } = await this.$http.post('/task/allstop')
        if (data.status == 'success') {
          this.$notify({
            type: 'success',
            message: '停用全部成功'
          })
          this.tableData.forEach(item => {
            item.stateswitch = 0
          })
        } else {
          this.$notify({
            type: 'danger',
            message: data.msg
          })
        }
      } catch (e) {
        this.$notify({
          type: 'danger',
          message: '网络异常，请稍后重试'
        })
      }
    },
    //启动正常
    async start_normal() {
      try {
        const { data } = await this.$http.post('/task/startnormal')
        if (data.status == 'success') {
          this.$notify({
            type: 'success',
            message: '启用正常成功'
          })
          this.tableData.forEach(item => {
            if (item.urlstate == 1) {
              item.stateswitch = 1
            }
          })
        } else {
          this.$notify({
            type: 'danger',
            message: data.msg
          })
        }
      } catch (e) {
        this.$notify({
          type: 'danger',
          message: '网络异常，请稍后重试'
        })
      }
    },
    //启动异常方法
    async start_abnorma() {
      try {
        const { data } = await this.$http.post('/task/startabnormal')
        if (data.status == 'success') {
          this.$notify({
            type: 'success',
            message: '启用异常成功'
          })
          this.tableData.forEach(item => {
            if (item.urlstate == 0) {
              item.stateswitch = 1
            }
          })
        } else {
          this.$notify({
            type: 'danger',
            message: data.msg
          })
        }
      } catch (e) {
        this.$notify({
          type: 'danger',
          message: '网络异常，请稍后重试'
        })
      }
    },
    //启动全部方法
    async start_all() {
      try {
        const { data } = await this.$http.post('/task/allstart')
        if (data.status == 'success') {
          this.$notify({
            type: 'success',
            message: '启用全部成功'
          })
          this.tableData.forEach(item => {
            item.stateswitch = 1
          })
        } else {
          this.$notify({
            type: 'danger',
            message: data.msg
          })
        }
      } catch (e) {
        this.$notify({
          type: 'danger',
          message: '网络异常，请稍后重试'
        })
      }
    },
    //启用未知
    async start_unknown() {
      try {
        const { data } = await this.$http.post('/task/start_unknown')
        if (data.status == 'success') {
          this.$notify({
            type: 'success',
            message: '启用未知成功'
          })
          this.tableData.forEach(item => {
            if (item.urlstate == 2) {
              item.stateswitch = 1
            }
          })
        } else {
          this.$notify({
            type: 'danger',
            message: data.msg
          })
        }
      } catch (e) {
        this.$notify({
          type: 'danger',
          message: '网络异常，请稍后重试'
        })
      }
    },
    //删除过期
    del_overdue() {
      this.$dialog.confirm({
        message: '您确认并要删除所有已过期的任务吗？',
      }).then(async () => {
        const { data } = await this.$http.post('/task/del_overdue', {
          page: this.page,
          eachpage: this.pagesize
        })
        if (data.status == 'success') {
          data.data.forEach(item => {
            item.loading = false
          })
          this.tableData = data.data
          this.total = data.total
          //当前页的计算
          if (this.total != 0) {
            var page = parseInt(this.total / this.pagesize) == 0 ? 1 : parseInt(this.total / this.pagesize)
            this.page = page
          } else {
            this.page = 1
          }
          this.$notify({
            type: 'success',
            message: '删除过期成功'
          })
          this.$store.commit('setOther', {
            name: 'monitored',
            value: data.total
          }) //修改仓库中已用任务额度
        } else {
          this.$notify({
            type: 'danger',
            message: data.msg
          })
        }
      })
    },
    //删除异常
    delabnormal() {
      this.$dialog.confirm({
        message: '您确认并要删除所有状态异常的任务吗？',
      }).then(async () => {
        const { data } = await this.$http.post('/task/delabnormal', {
          page: this.page,
          eachpage: this.pagesize
        })
        if (data.status == 'success') {
          data.data.forEach(item => {
            item.loading = false
          })
          this.tableData = data.data
          this.total = data.total
          //当前页的计算
          if (this.total != 0) {
            var page = parseInt(this.total / this.pagesize) == 0 ? 1 : parseInt(this.total / this.pagesize)
            this.page = page
          } else {
            this.page = 1
          }
          this.$notify({
            type: 'success',
            message: '删除异常成功'
          })
          this.$store.commit('setOther', {
            name: 'monitored',
            value: data.total
          }) //修改仓库中已用任务额度
        } else {
          this.$notify({
            type: 'danger',
            message: data.msg
          })
        }
      }).catch(() => {
      })
    },
    //删除正常
    delnormal() {
      this.$dialog.confirm({
        message: '您确认并要删除所有状态正常的任务吗？',
      }).then(async () => {
        const { data } = await this.$http.post('/task/delnormal', {
          page: this.page,
          eachpage: this.pagesize
        })
        if (data.status == 'success') {
          data.data.forEach(item => {
            item.loading = false
          })
          this.tableData = data.data
          this.total = data.total
          //当前页的计算
          if (this.total != 0) {
            var page = parseInt(this.total / this.pagesize) == 0 ? 1 : parseInt(this.total / this.pagesize)
            this.page = page
          } else {
            this.page = 1
          }
          this.$notify({
            type: 'success',
            message: '删除正常成功'
          })
          this.$store.commit('setOther', {
            name: 'monitored',
            value: data.total
          }) //修改仓库中已用任务额度
        } else {
          this.$notify({
            type: 'danger',
            message: data.msg
          })
        }
      }).catch(() => {
      })
    },
    //删除未知
    del_unknown() {
      this.$dialog.confirm({
        message: '您确认并要删除所有状态未知的任务吗？',
      }).then(async () => {
        const { data } = await this.$http.post('/task/del_unknown', {
          page: this.page,
          eachpage: this.pagesize
        })
        if (data.status == 'success') {
          data.data.forEach(item => {
            item.loading = false
          })
          this.tableData = data.data
          this.total = data.total
          //当前页的计算
          if (this.total != 0) {
            var page = parseInt(this.total / this.pagesize) == 0 ? 1 : parseInt(this.total / this.pagesize)
            this.page = page
          } else {
            this.page = 1
          }
          this.$notify({
            type: 'success',
            message: '删除未知成功'
          })
          this.$store.commit('setOther', {
            name: 'monitored',
            value: data.total
          }) //修改仓库中已用任务额度
        } else {
          this.$notify({
            type: 'danger',
            message: data.msg
          })
        }
      }).catch(() => {
      })
    },
    //修改任务
    editshow(row) {
      this.showMonitorinfo = 3
      this.editRow = row
    },
    // 修改成功更新视图
    editsuccess(data) {
      data.data.forEach(item => {
        item.loading = false
      })
      this.tableData = data.data
      this.total = data.total
    },
    //添加成功更新视图
    addsucess(data) {
      data.data.forEach(item => {
        item.loading = false
      })
      this.tableData = data.data
      this.total = data.total
      this.$store.commit('setOther', {
        name: 'monitored',
        value: data.total
      }) //修改仓库中已用任务额度
    },
    //删除启用
    delstart() {
      this.$dialog.confirm({
        message: '您确认并要删除所有已启用的任务吗？',
      }).then(async () => {
        const { data } = await this.$http.post('/task/delstart', {
          page: this.page,
          eachpage: this.pagesize
        })
        if (data.status == 'success') {
          data.data.forEach(item => {
            item.loading = false
          })
          this.tableData = data.data
          this.total = data.total
          //当前页的计算
          if (this.total != 0) {
            var page = parseInt(this.total / this.pagesize) == 0 ? 1 : parseInt(this.total / this.pagesize)
            this.page = page
          } else {
            this.page = 1
          }
          this.$notify({
            type: 'success',
            message: '删除启用成功'
          })
          this.$store.commit('setOther', {
            name: 'monitored',
            value: data.total
          }) //修改仓库中已用任务额度
        } else {
          this.$notify({
            type: 'danger',
            message: data.msg
          })
        }
      }).catch(() => {
      })
    },
    //删除停用
    delstop() {
      this.$dialog.confirm({
        message: '您确认并要删除所有已停用的任务吗？',
      }).then(async () => {
        const { data } = await this.$http.post('/task/delstop', {
          page: this.page,
          eachpage: this.pagesize
        })
        if (data.status == 'success') {
          data.data.forEach(item => {
            item.loading = false
          })
          this.tableData = data.data
          this.total = data.total
          //当前页的计算
          if (this.total != 0) {
            var page = parseInt(this.total / this.pagesize)
            this.page = page
          } else {
            this.page = 1
          }
          this.$notify({
            type: 'success',
            message: '删除停用成功'
          })
          this.$store.commit('setOther', {
            name: 'monitored',
            value: data.total
          }) //修改仓库中已用任务额度
        } else {
          this.$notify({
            type: 'danger',
            message: data.msg
          })
        }
      }).catch(() => {
      })
    },
    //停用的公共方法
    async stop(idlist) {
      try {
        const { data } = await this.$http.post('/task/selectstop', { id: idlist })
        if (data.status == 'success') {
          this.selection = ''
          this.selectedArray = []
          let arr = idlist.split(',')
          arr.forEach(item1 => {
            let index = this.tableData.findIndex(item => {
              return item.id == item1
            })
            this.tableData[index].ischecked = false
            this.tableData[index].stateswitch = 0
          })
          this.$notify({
            type: 'success',
            message: data.msg
          })
        } else {
          this.$notify({
            type: 'danger',
            message: data.msg
          })
        }
      } catch (e) {
        this.$notify({
          type: 'danger',
          message: '网络异常，请稍后重试'
        })
      }
    },
    //停用选中
    stop_check() {
      this.stop(this.selection)
    },
    // 启动的公共方法
    async start(idlist) {
      this.selectedArray = []
      try {
        const { data } = await this.$http.post('/task/selectstart', { id: idlist })
        if (data.status == 'success') {
          this.selection = ''
          this.selectedArray = []
          let arr = idlist.split(',')
          arr.forEach(item1 => {
            let index = this.tableData.findIndex(item => {
              return item.id == item1
            })
            this.tableData[index].ischecked = false
            this.tableData[index].stateswitch = 1
          })
          this.$notify({
            type: 'success',
            message: data.msg
          })
        } else {
          this.$notify({
            type: 'danger',
            message: data.msg
          })
        }
      } catch (e) {
        this.$notify({
          type: 'danger',
          message: '网络异常，请稍后重试'
        })
      }
    },
    // 启动选中
    async start_check() {
      this.start(this.selection)
    },
    // 更改自动停用状态
    change_switch(id) {
      this.tableData.forEach(async (item, index) => {
        if (item.id == id) {
          if (this.tableData[index].switch == 1) {
            const { data } = await this.$http.post('/task/abnormalstop', { id: id })
            if (data.status == 'success') {
              this.$notify({
                type: 'success',
                message: data.msg
              })
              this.tableData[index].switch = 0
            } else {
              this.$notify({
                type: 'success',
                message: data.msg
              })
            }
          } else {
            const { data } = await this.$http.post('/task/abnormalstart', { id: id })
            if (data.status == 'success') {
              this.$notify({
                type: 'success',
                message: data.msg
              })
              this.tableData[index].switch = 1
            } else {
              this.$notify({
                type: 'success',
                message: data.msg
              })
            }
          }
        }
      })
    },
    //更改任务开启状态
    change_stateswitch(id) {
      const index = this.tableData.findIndex(item => {
        return id == item.id
      })
      if (this.tableData[index].stateswitch == 0) {
        this.start(id + '')
      } else {
        this.stop(id + '')
      }
    },
    //选中项变化的时候
    changecheck(id) {
      if(this.selectedArray.indexOf(id) !== -1) {
        this.selectedArray.splice(this.selectedArray.indexOf(id),1)
      }else {
        this.selectedArray.push(id)
      }
      this.tableData.forEach(item=>{
        this.selectedArray.forEach(data=>{
          if(item.id == data){
            item.ischecked = true
          }
        })
      })
      this.selection = this.selectedArray.join()
    },
    //公共的删除方法
    async delmethod(idlist, page, pagesize) {
      this.loading = true
      const { data } = await this.$http.post('/task/selectdel', {
        id: idlist,
        page: page,
        eachpage: pagesize
      })
      if (data.status == 'success') {
        data.data.forEach(item => {
          item.loading = false
          item.ischecked = false
        })
        this.selection = ''
        this.selectedArray = []
        this.tableData = data.data
        this.total = data.total
        this.$notify({
          type: 'success',
          message: '删除成功'
        })
        this.$store.commit('setOther', {
          name: 'monitored',
          value: data.total
        }) //修改仓库中已用任务额度
      } else {
        this.$notify({
          type: 'danger',
          message: data.msg
        })
      }
      this.loading = false
    },
    //删除单个
    async delrow(id) {
      this.showMoreBox = []
      if (this.selection.split(',').length == this.tableData.length) {
        this.page -= 1
      }
      this.delmethod(id, this.page, this.pagesize)
    },
    // 删除选中
    delcheck() {
      if (this.selection == '') {
        return this.$notify({
          type: 'danger',
          message: '未选择任何任务'
        })
      }
      this.$dialog.confirm({
        message: '确定要删除选中任务吗?',
      }).then(() => {
        if (this.selection.split(',').length == this.tableData.length) {
          if (this.page > 1) {
            this.page -= 1
          } else {
            this.page = 1
          }
        }
        this.delmethod(this.selection, this.page, this.pagesize)
      })
    },
    //删除全部
    async delall() {
      this.$dialog.confirm({
        title: '提示',
        message: '确认要删除所有的任务吗',
      }).then(async () => {
        const { data } = await this.$http.post('/task/delall')
        if (data.status == 'success') {
          this.tableData = []
          this.total = 0
          this.$notify({
            type: 'success',
            message: '删除成功'
          })
          this.$store.commit('setOther', {
            name: 'monitored',
            value: data.total
          }) //修改仓库中已用任务额度
        } else {
          this.$notify({
            type: 'danger',
            message: data.msg
          })
        }
      }).catch(() => {
        // this.$notify({type:'warning',message:'已取消删除',duration:1000})
      })
    },
    closeView(bool) {
      this.dialogVisible = bool
    },

    enter(row) {
      row.tooltip = true
    },
    leave(row) {
      row.tooltip = false
    }
  }
}
</script>

<style lang="less" scoped>
.monitor-container {
  height: 100vh;
  overflow: auto;
  // 日志按钮
  .journal {
    color: #1989fa;
    font-weight: bold;
    font-size: 1rem;
  }

  // 搜索框
  /deep/ .van-search {
    .van-search__content--round {
      border: 1px solid #303133;
      background-color: #F7F8FC;
    }

    .van-cell {
      padding: 0.5rem;
    }
  }

  // 添加任务按钮
  .addTaskBtn {
    position: fixed;
    bottom: 20%;
    right: 0.5rem;
    z-index: 1000;
    border-radius: 50%;
    font-size: 2rem;
    padding: 0.2rem 0.65rem;
  }

  // 操作按钮grid
  /deep/ .OperationButtonGrid {
    background-color: #ffffff;
    border-top: 1px solid #f6f6f6;
    border-bottom: 1px solid #f6f6f6;

    .el-link.is-underline:hover:after {
      border: none;
    }

    .van-grid-item {
      .van-grid-item__content {
        padding: 1rem 0;

        .el-button {
          border: none;
          padding: 0;
          font-size: 0.9rem;
        }

        .el-button:focus, .el-button:hover {
          color: unset;
          background-color: unset;
          border-color: unset;
        }

        .el-dropdown-menu {
          .el-dropdown-item {
            font-weight: bold;
          }
        }
      }
    }
  }

  .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
    border: none;
  }

  // 监控任务列表
  /deep/ .panelMonitor {
    margin: 0.6rem;
    border-radius: 1rem;

    .van-panel__header {
      display: none;
    }

    .van-panel__footer {
      text-align: right;
      .el-checkbox{
        float: left;
        line-height: 32px;
      }
      .el-button--success.is-plain:focus, .el-button--success.is-plain:hover {
        color: #67c23a;
        background-color: #f0f9eb;
        border-color: #c2e7b0;
      }
    }

    .van-grid {
      .van-grid-item {
        .van-grid-item__content {
          padding: 0;
          border-radius: 1rem;
        }
      }

      .van-grid-item:nth-of-type(1) {
        padding-left: 0.7rem;

        .van-grid-item__content {
          align-items: flex-start;

          .monitorName {
            font-size: 1.1rem;
            margin: 0.4rem 0;
            color: #409EFF;
            font-weight: bold;
          }

          .monitorContent {
            line-height: 1.5rem;
            color: #303133;
          }
        }
      }

      .van-grid-item:nth-of-type(2) {
        .van-grid-item__content {
          align-items: flex-end;
          position: relative;
          // 未知状态 以及默认样式
          .invoicing {
            font-size: 0.8rem;
            position: absolute;
            top: 0;
            right: 0;
            padding: 0.25rem 0.75rem;
            border-radius: 0 1rem 0 1rem;
            background-color: #f4f4f5;
            color: #909399;
          }

          // 异常状态
          .invoicing0 {
            background-color: #FEF0F0;
            color: #DA2153;
          }

          // 正常状态
          .invoicing1 {
            background-color: #F0F9EB;
            color: #67C23A;
          }
        }
      }
    }
  }

  .el-icon--right {
    margin-left: 0;
  }

  .icon {
    width: 2em;
    height: 2em;
    vertical-align: middle;
    margin-left: 10px;
  }

  .dingding_icon {
    width: 2.3em;
    height: 2.3em;
  }

  .nowCan_add {
    color: #ccc;
    font-size: 12px;
    margin-right: 10px;
  }

  /deep/ .FilterTabBar {
    .van-tabs__nav--complete {
      padding-right: 0;

      .van-tab {
        padding-left: 0;

        .van-tab__text {
          .van-tag {
            //font-size: 0.9rem;
            font-weight: bold;
            background-color: #F7F8FC;
            color: #909399;
            display: flex;
            align-items: center;
          }
        }

        .el-dropdown {
          .el-dropdown-menu {
            margin: 0 0.4rem;
          }
        }
      }
    }
  }
}

.van-checkbox-group {
  padding: 0.5rem;
  .van-checkbox {
    font-size: 0.9rem;
    margin: 0 0 0.5rem;

    .van-checkbox__icon {
      font-size: 0.9rem;
    }

    .van-checkbox__label {
      margin-left: 0.35rem;
    }
  }

  .van-checkbox:last-child {
    margin-bottom: 0;
  }
}
.deleteBtn{
  display: flex;
  align-items: center;
  justify-content: center;
  color: red;
  .van-icon{
    margin-right:3px;
  }
}
</style>

<style lang="less">
.van-popover[data-popper-placement='bottom'] {
  left: 0 !important;
  width: 100%;
}
</style>
